// assets/cielo-accordion.js
(() => {
  const SCOPE  = '.accordion-section, .spec-accordion-container';
  const TOGGLE = '.accordion-toggle';
  const PANEL  = '.accordion-panel';

  function setOpen(el, panel, open) {
    el.classList.toggle('active', open);
    el.setAttribute('aria-expanded', open ? 'true' : 'false');
    // パネルは状態の“結果”だけを反映
    panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
  }

  function normalize(scope) {
    const el    = scope.querySelector(TOGGLE);
    const panel = scope.querySelector(PANEL);
    if (!el || !panel) return;

    // 初期状態の決定基準：active / aria / data-open
    const markedOpen =
      el.classList.contains('active') ||
      el.getAttribute('aria-expanded') === 'true' ||
      el.dataset.open === 'true';

    setOpen(el, panel, !!markedOpen);

    // コンテンツ高さが変わった時に追随
    if (!panel._ro) {
      panel._ro = new ResizeObserver(() => {
        if (el.classList.contains('active')) {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        }
      });
      panel._ro.observe(panel);
    }
  }

  function setup(root = document) {
    root.querySelectorAll(SCOPE).forEach(normalize);
  }

  // クリック委譲：DOM差し替え後も効く
  document.addEventListener('click', e => {
    const el = e.target.closest(TOGGLE);
    if (!el) return;

    const scope = el.closest(SCOPE);
    const panel = scope && scope.querySelector(PANEL);
    if (!panel) return;

    const willOpen = !el.classList.contains('active'); // 状態はトグル基準
    setOpen(el, panel, willOpen);
  });

  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup());
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', e => setup(e.target));
  document.addEventListener('turbo:load', () => setup());
  document.addEventListener('page:load', () => setup());
})();
